import Setting from "../features/settings/Settings";

const Settings = () => {
    return (
        <>
            <Setting />
        </>
    )
}

export default Settings